exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".parallax{perspective:1px;height:100vh;overflow-x:hidden;overflow-y:auto}.parallax__layer{position:absolute;top:0;right:0;bottom:0;left:0}.parallax__layer--base{transform:translateZ(0);z-index:1;position:relative}.parallax__layer--back-1{transform:translateZ(-1px) scale(4);z-index:-1}.parallax__layer--back-2{transform:translateZ(-2px) scale(3);z-index:-2}.parallax__group{position:relative;height:50vh;transform-style:preserve-3d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?includePaths[]=D:/Fullstack/portfolio-site/react-portfolio/~/bourbon/app/assets/stylesheets!./src/styles/parallax.scss
// module id = 129
// module chunks = 0